import { autoinject } from 'aurelia-framework';
import { ServiceCubicWasteProduct } from 'models/ServiceCubicWasteProduct';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class ServiceCubicWasteProductService extends BaseApiService<ServiceCubicWasteProduct> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, ServiceCubicWasteProduct);
  }
}
